import type { ReactNode } from 'react'
type Props = {
  children: ReactNode
}

export const DiffTitle = ({ children }: Props) => (
  <h4 className="font-bold uppercase">{children}</h4>
)
